import { render, staticRenderFns } from "./ButtonUpload.vue?vue&type=template&id=2fa83b2c"
import script from "./ButtonUpload.vue?vue&type=script&lang=js"
export * from "./ButtonUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports